module.exports = __webpack_public_path__ + "static/img/10.433b9e17.png";